<template>
  <v-sheet
    max-width="380"
    class="mx-auto"
    color="transparent"
  >
    <v-form
      @submit.prevent="$v.$invalid ? null : submit()"
      ref="form"
      class="my-10"
    >
      <v-text-field
        :rules="[requiredRule, minimumTo8,minimumOneDigit, minimumOneCapitalLetter, minimumOneCharacterNotAlphaNumeric]"
        :append-icon="showPwd ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showPwd ? 'text' : 'password'"
        @input="$v.password.$touch()"
        @blur="$v.password.$touch()"
        prepend-inner-icon="lock"
        v-model="password"
        label="Password"
        @click:append="showPwd = !showPwd"
        solo
        flat
      />
      <v-text-field
        type="password"
        label="Confirm Password"
        v-model="repeatPassword"
        :rules="[requiredRule, sameAsPassword]"
        @input="$v.repeatPassword.$touch()"
        @blur="$v.repeatPassword.$touch()"
        prepend-inner-icon="enhanced_encryption"
        required
        solo
        flat
      ></v-text-field>

      <v-btn
        block
        type="submit"
        :disabled="$v.$invalid"
        :loading="loader"
      >{{ $t("Global.ForgotPassword.sendText") }}</v-btn>
    </v-form>

    <v-snackbar
        v-model="snackbar"
        right
        :timeout="snackbarTimeout"
        :color="snackbarColor"
        class="mt-6"
    >
      <span>{{ snackbarMessage }}</span>
      <v-icon class="ml-2" dark>{{ snackbarIcon }}</v-icon>
      <template v-slot:action="{ attrs }">
        <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="snackbar = false"
        >
          {{ $t("Global.ConfirmDialog.buttonTextClose") }}
        </v-btn>
      </template>
    </v-snackbar>

  </v-sheet>
</template>

<script>
import { required, sameAs } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import snackBar from "@/mixins/snackBarMixin";
import loader from "@/mixins/Loader";
import PasswordRecoveryApi from "@/mixins/Services/PasswordRecoveryApi";
import Utils from "@/mixins/Utils";
export default {
  mixins: [PasswordRecoveryApi, validationMixin, Utils, snackBar, loader],
  props: {
    token: {
      type: String,
      default: '',
      required: true
    },
  },
  validations: {
    password: { required },
    repeatPassword: {
      sameAsPassword: sameAs("password")
    }
  },
  data () {
    return {
      errors: null,
      password: null,
      repeatPassword: null,
      loader: false,
      showPwd: false,
      sameAsPassword : () => this.password === this.repeatPassword || this.$t('Global.FormRules.passwordsDoNotMatch'),
      requiredRule: v => !!v || this.$t('Global.FormRules.requiredField'),
      minimumTo8: v => v == null || v === "" || v.length > 7 ? true : this.$t('Global.FormRules.minimumTo8'),
      minimumOneDigit: v => v == null || v === "" || !!v.match(/\d+/)? true : this.$t('Global.FormRules.minimumOneDigit'),
      minimumOneCapitalLetter: v => v == null || v === "" || !!v.match(/[A-Z]+/)? true : this.$t('Global.FormRules.minimumOneCapitalLetter'),
      minimumOneCharacterNotAlphaNumeric: v => v == null || v === "" || !!v.match(/\W+/)? true : this.$t('Global.FormRules.minimumOneCharacterNotAlphaNumeric')
    };
  },
  methods: {
    async submit () {
      try {
        this.setLoader(true)
        const user = await this.getUserByPasswordResetToken(this.token)
        await this.createNewPasswordRecovery({userId: user.userId, newPassword: this.password})
        this.setLoader(false)
        this.$emit("complete", true);
      } catch (e) {
        this.setLoader(false)
        console.error('[RESET-PASSWORD][submit] ERROR:', e)
        if(this.isErrorText(e)){
          const textError = this.getErrorText(e);
          this.launchSnackbar(this.$t(`Global.Error.c${textError}`), 'error', "2000", 'mdi-alert-octagon')
        }
      }
    },
  },
};
</script>
